<template>
  <div>
    <div class="card">
      <div class="card-header"><h4>Adiconar Rede Social</h4></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <label for="nome">Nome</label>
            <input
              id="nome"
              type="text"
              class="form-control"
              placeholder="Digite um nome"
              v-model="state.rede.nome.value"
            />
            <span v-if="state.rede.nome.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="desc">Valor (@)</label>
            <input
              id="desc"
              type="text"
              class="form-control"
              placeholder="Ex: @AutFriends"
              v-model="state.rede.valor.value"
            />
            <span v-if="state.rede.valor.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="desc">Link</label>
            <input
              id="desc"
              type="text"
              class="form-control"
              placeholder="Link"
              v-model="state.rede.link.value"
            />
            <span v-if="state.rede.link.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="btns_right">
          <button @click="saveRede" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/redes-sociais">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      rede: {
        id: "",
        nome: {
          value: "",
          error: false,
        },
        valor: {
          value: "",
          error: false,
        },
        link: {
          value: "",
          error: false,
        },
      },
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetch();
      }
    });
    async function fetch() {
      try {
        const { data } = await services.redes_sociais.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.rede.id = data.id;
        state.rede.nome.value = data.nome;
        state.rede.valor.value = data.valor;
        state.rede.link.value = data.link;
      } catch (error) {
        console.log(error);
      }
    }
    async function saveRede() {
      var erro_validacao = false;

      if (state.rede.nome.value.length == 0) {
        state.rede.nome.error = true;
        erro_validacao = true;
      }
      if (state.rede.valor.value.length == 0) {
        state.rede.valor.error = true;
        erro_validacao = true;
      }
      if (state.rede.link.value.length == 0) {
        state.rede.link.error = true;
        erro_validacao = true;
      }

      if (erro_validacao == true) {
        return;
      }
      if (!state.rede.id) {
        await services.redes_sociais
          .save({
            nome: state.rede.nome.value,
            valor: state.rede.valor.value,
            link: state.rede.link.value,
            token,
          })
          .then((data) => {
            console.log(data);
            router.push({ name: "Usuarios" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      } else {
        await services.redes_sociais.update({
          id: state.rede.id,
          nome: state.rede.nome.value,
          valor: state.rede.valor.value,
          link: state.rede.link.value,
          token,
        });
        router
          .push({ name: "RedesSociais" })
          .then((data) => {
            console.log(data);
            router.push({ name: "Usuarios" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      }
    }
    return {
      saveRede,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #47b0a9;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #47b0a9;
}
.btns_right {
  text-align: right;
  margin-top: 1rem;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
textarea {
  resize: none;
  border: solid 1px #000;
}
textarea:focus {
  border: solid 1px #47b0a9;
}
#pills-home-tab {
  color: #000;
}
#pills-home-tab:focus {
  color: #47b0a9;
}
#pills-profile-tab {
  color: #000000;
}
#pills-profile-tab:focus {
  color: #47b0a9;
}
.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}
tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}
thead {
  color: #000;
  text-align: center;
  background: gray;
}
td {
  color: #000;
  text-align: center;
}
.table {
  margin-top: 2rem;
}
.imagem {
  width: 100%;
  height: auto;
  -o-object-fit: cover;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
}
.btn_deletar_imagem {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  margin-top: 2rem;
  background: #c4342d;
  color: #000;
  border: solid 1px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_deletar_imagem:hover {
  background: #8f0303;
  border: solid 1px #000;
}
</style>